export default __webpack_public_path__ + "static/media/image_7.dd1c4871.jpg";